import './pricing_table_block/index.js';
import './membership_form_block/index.js';
import './login_form_block/index.js';
